import React, { useState, useEffect, createContext } from "react";
import { hasExpiredToken } from "../utils/token";
import {
  getAccessToken,
  getRefreshToken,
  refreshAccessToken,
  setAccessToken,
  removeTokens
} from "../api/auth";

import {
    getMe
  } from "../api/user";

export const AuthContext = createContext();

export default function AuthProvider(props) {
    const { children } = props;
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [laoding, setLaoding] = useState(true);

    useEffect(() => {
      (async () => {
        const accessToken = getAccessToken();
        const refreshToken = getRefreshToken();




        if (!accessToken || !refreshToken || accessToken === 'undefined' || refreshToken === 'undefined' ) {
          logout();
          setLaoding(false);
          return;
        }

        if (hasExpiredToken(accessToken)) {
          if (hasExpiredToken(refreshToken)) {
            logout();
          } else {
            await reLogin(refreshToken);
          }
        } else {
          await login(accessToken);
        }

        setLaoding(false);
      })();
    }, []);

    const reLogin = async (refreshToken) => {
      try {
        const { accessToken } = await refreshAccessToken(
          refreshToken
        );
        setAccessToken(accessToken);
        await login(accessToken);
      } catch (error) {
        console.error(error);
      }
    };

    const login = async (accessToken) => {
      try {
        const response = await getMe(accessToken);
        delete response.password;

        setUser(response);
        setToken(accessToken);
      } catch (error) {
        console.error(error);
      }
    };

    const logout = () => {
      setUser(null);
      setToken(null);
      removeTokens();
    };

    const data = {
      accessToken: token,
      user,
      login,
      logout,
    };

    if (laoding) return null;

    return <AuthContext.Provider value={data}>{children}</AuthContext.Provider>;
  }
